import React, {useState, useEffect} from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import {Field} from 'formik';
import Dropzone from 'react-dropzone';
import {FormattedMessage} from 'react-intl';
import Button from '../Button';
import LabelInput from '../LabelInput';
import LabelInfo from '../LabelInfo';
import camera from '../../assets/icon-camera.svg';
import ok from '../../assets/icon-check-circle.svg'
import 'react-datepicker/dist/react-datepicker.css';
import styles from './styles.module.scss';

const FieldFileUpload = ({
                           fieldId,
                           label,
                           info,
                           cameraLabel,
                           containerStyles = null,
                           icon = camera,
                           isFileUploaded = false,
                           onChange,
                           ...rest
                         }) => {
  const [fileUploaded, setFileUploaded] = useState(false);

  useEffect(() => {
    setFileUploaded(isFileUploaded)
  }, [isFileUploaded]);

  const uploadFile = (form, field) => acceptedFiles => {
    form.setFieldValue(field.name, acceptedFiles);
    setFileUploaded(true);
    if (onChange) {
      onChange(form, field, setFileUploaded)(acceptedFiles);
    }
  };

  const removeFile = (form, field) => {
    form.setFieldValue(field.name, null);
    setFileUploaded(false);
  };

  return (
    <Field
      id={fieldId}
      name={fieldId}
    >
      {({field, form, meta}) => (
        <div className={classnames(styles.uploadContainer, containerStyles)}>
          <div className={styles.label}>
            <LabelInput label={label} bold={false}/>
            <LabelInfo label={info} bold={false}/>
          </div>
          {
            (fileUploaded)
              ? (
                <div
                  className={classnames(styles.dropzone, styles.withFile, {[styles.errorBorder]: meta.error && meta.touched})}>
                  <img src={ok} alt="info" className={styles.info}/>
                  <div className={styles.uploadedLabel}>
                    <FormattedMessage
                      id='common.uploaded.label'
                      defaultMessage='The file was uploaded successfully'
                    />
                  </div>
                  <Button
                    variant='secondary'
                    onClick={() => removeFile(form, field)}
                    className={styles.removeFile}
                    label={(
                      <FormattedMessage
                        id='common.uploaded.button.remove'
                        defaultMessage='Remove'
                      />
                    )}
                  />
                </div>
              )
              : (
                <Dropzone
                  onDrop={uploadFile(form, field)}
                  multiple={false}
                >
                  {({getRootProps, getInputProps}) => (
                    <div
                      {...getRootProps()}
                      className={classnames(styles.dropzone, {[styles.errorBorder]: meta.error && meta.touched})}
                    >
                      <input {...getInputProps()} {...rest} />
                      <img src={icon} alt="camera" className={styles.camera}/>
                      <div className={styles.labelCamera}>{cameraLabel}</div>
                    </div>
                  )}
                </Dropzone>
              )
          }

        </div>
      )}
    </Field>
  )
};

FieldFileUpload.propTypes = {
  fieldId: PropTypes.string.isRequired,
  label: PropTypes.node,
  containerStyles: PropTypes.string,
  isFileUploaded: PropTypes.bool,
};

export default FieldFileUpload;
